import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: true
})
export class FilterPipe implements PipeTransform {
  transform(listArray: any[] | null | undefined, field: string | null = null, search: string = ''): any[] {
    if(!listArray) {return []}
    const array = listArray.slice();

    if(!search || !search.trim()) {
      return array;
    }

    return array.filter(item => {
      if(field) {
        return item[field].toLowerCase().includes(search.toLowerCase());
      }
      return item.toLowerCase().includes(search.toLowerCase());
    })
  }

}
